var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_2607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6262 5.83301C40.9957 5.83334 42.3214 6.31552 43.3712 7.19509L43.7503 7.54217L56.6245 20.4163C57.5929 21.3847 58.1897 22.663 58.3103 24.0272L58.3337 24.5405V58.333C58.3341 59.8047 57.7783 61.2222 56.7776 62.3013C55.7769 63.3804 54.4054 64.0414 52.9378 64.1518L52.5003 64.1663H17.5003C16.0286 64.1668 14.6112 63.611 13.5321 62.6103C12.4529 61.6096 11.792 60.238 11.6816 58.7705L11.667 58.333V11.6663C11.6665 10.1947 12.2223 8.77719 13.223 7.69808C14.2237 6.61896 15.5953 5.95797 17.0628 5.84759L17.5003 5.83301H39.6262ZM35.0003 11.6663H17.5003V58.333H52.5003V29.1663H39.3753C38.2878 29.1663 37.2392 28.7612 36.4341 28.03C35.629 27.2987 35.1251 26.2939 35.0207 25.2113L35.0003 24.7913V11.6663ZM37.882 34.5563C38.5802 38.9986 40.9033 43.0232 44.4007 45.8497C46.9878 47.9409 44.6224 52.0359 41.5191 50.843C37.3234 49.2275 32.6773 49.2275 28.4816 50.843C25.3753 52.0388 23.0099 47.9409 25.597 45.8497C29.0945 43.0232 31.4176 38.9986 32.1157 34.5563C32.6349 31.2693 37.3657 31.2722 37.882 34.5563ZM34.9945 41.2763L32.9878 44.7647H37.0128L34.9945 41.2763ZM40.8337 12.8738V23.333H51.2928L40.8337 12.8738Z",
    fill: "#9747FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_2607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfImage);
export default __webpack_public_path__ + "static/media/pdfImage.26ce19a434a8d0cad0c0e32b6705b2e5.svg";
export { ForwardRef as ReactComponent };